import { render, staticRenderFns } from "./ApplicantMessageHistoryStatus.vue?vue&type=template&id=5c6348d0"
import script from "./ApplicantMessageHistoryStatus.vue?vue&type=script&lang=js"
export * from "./ApplicantMessageHistoryStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports